<template>
  <div>
    <v-row justify="center">
      <v-dialog max-width="600px" persistent v-model="dialogUploadFotoForm">
        <v-card>
          <v-toolbar color="grey lighten-4" flat dark>
            <v-toolbar-title class="text-h6 grey--text">Adicionar Foto</v-toolbar-title>
            <v-spacer />
          </v-toolbar>
          <v-form>
            <v-card-text class="pb-0">
              <v-file-input
                v-model="formData.foto"
                accept="image/*"
                label="Foto"
                dense
                clearable
                outlined
                show-size
                @change="getPreview"
                ref="foto"
              >
              </v-file-input>
              <Cropper
                ref="cropper"
                class="cropper"
                :src="url"
                v-if="url"
                :stencil-props="{
                  aspectRatio: 3 / 4,
                }"
              ></Cropper>
              <v-responsive v-if="imgUrl">
                <v-img :src="imgUrl" :aspect-ratio="3 / 4" contain></v-img>
              </v-responsive>
            </v-card-text>
            <v-card-actions class="pa-4">
              <v-spacer></v-spacer>
              <v-btn @click="toggleUploadFotoForm" color="red" dark depressed>
                <v-icon left small>mdi-close</v-icon>
                Fechar
              </v-btn>
              <v-btn type="button" @click="cropImage" color="teal" v-if="url" dark depressed>
                <v-icon left small>mdi-crop</v-icon>
                Cortar
              </v-btn>
              <v-btn
                v-if="imgUrl"
                :disabled="!valid"
                :loading="isloadingSubmit"
                color="green"
                dark
                depressed
                @click="submit"
              >
                <v-icon left small>mdi-send</v-icon>
                Salvar
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import { Cropper } from 'vue-advanced-cropper';
import { mapActions, mapState } from 'vuex';
import toastMessage from '@/services/util/alertService';

export default {
  name: 'ModalUploadFotoForm',
  components: { Cropper },
  data: () => ({
    valid: true,
    url: null,
    imgUrl: null,
    canvas: null,
    formData: {
      foto: null,
    },
    formDataDefault: {
      foto: null,
    },
    isloadingSubmit: false,
  }),
  computed: {
    ...mapState('pessoa', ['dialogUploadFotoForm', 'data']),
  },
  methods: {
    ...mapActions('pessoa', ['toggleUploadFotoForm', 'updateFoto']),
    getPreview() {
      if (this.formData.foto) {
        const fr = new FileReader();
        fr.readAsDataURL(this.formData.foto);
        fr.addEventListener('load', () => {
          this.url = fr.result;
        });
      } else {
        this.url = null;
        this.imgUrl = null;
        this.canvas = null;
      }
    },
    cropImage() {
      const { canvas } = this.$refs.cropper.getResult();
      this.canvas = canvas;
      this.cropedImage();
    },
    cropedImage() {
      this.imgUrl = this.canvas.toDataURL('image/jpeg');
      this.url = undefined;
    },
    submit() {
      if (this.canvas) {
        const form = new FormData();
        this.canvas.toBlob((blob) => {
          form.append('foto', blob);
          form.append('cgm_id', this.data.id);
          this.updateFoto(form)
            .then(() => {
              toastMessage.successSave('Upload efetuado com sucesso.');
              this.toggleUploadFotoForm();
            })
            .catch(() => toastMessage.errorSave('Erro ao enviar foto.'));
        }, 'image/jpeg');
      }
    },
    closeDialogForm() {
      setTimeout(() => {
        Object.entries(this.formDataDefault).forEach(([key]) => {
          this.formData[key] = this.formDataDefault[key];
        });
      }, 300);
      this.url = null;
      this.imgUrl = null;
      this.canvas = null;
    },
  },
  watch: {
    dialogUploadFotoForm() {
      this.closeDialogForm();
    },
  },
};
</script>
